import styled from "styled-components";
import { Aggregator, theme } from "ui";

export const UtilInfoOptionContainer = styled(Aggregator)`
  color: ${theme.colors.neutral.white};
`;

export const ImageInfoOptionContainer = styled(Aggregator)``;
